

function Menu() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M26 7.5L2 7.5L2 5L26 5V7.5Z" fill="currentColor"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M26 23.5H2L2 21H26V23.5Z" fill="currentColor"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M26 15.5L2 15.5V13L26 13V15.5Z" fill="currentColor"/>
    </svg>
  )
}

export default Menu